/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
import { find, get } from 'lodash';
import { reactLocalStorage } from 'reactjs-localstorage';
import slug from 'slug';

const MyUtil = {
  slug: (str) => slug(str.toLowerCase()),
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  },
  currencyFormat: (amount) => {
    const amountAsNumber = Number(amount) || 0;
    return amountAsNumber.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  },
  subStringCurrency(curency) {
    return curency.substr(0, curency.length - 1);
  },
  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  getDateFormat(date) {
    const dateFormat = new Date(date);
    const { day, month } = MyUtil.getMonthDay(dateFormat);
    return `${day}/${month}/${dateFormat.getFullYear()}`;
  },
  getDateFormatEn(date) {
    const { day, month } = MyUtil.getMonthDay(date);
    return `${month}/${day}/${date.getFullYear()}`;
  },
  getDatetimeFormat(datetime) {
    const date = new Date(datetime);
    const { day, month } = MyUtil.getMonthDay(date);
    const { hour, minute } = MyUtil.getHourMinute(date);
    return `${hour}:${minute} ${day}/${month}/${date.getFullYear()}`;
  },
  getDatetimeFormatForm(datetime) {
    const date = new Date(datetime);
    const { day, month } = MyUtil.getMonthDay(date);
    const { hour, minute } = MyUtil.getHourMinute(date);
    return `${day}/${month}/${date.getFullYear()} ${hour}:${minute}`;
  },
  getDatetimeFormatCrta(date) {
    const { day, month } = MyUtil.getMonthDay(date);
    const { hour, minute } = MyUtil.getHourMinute(date);
    return `${hour}:${minute} ${day}-${month}-${date.getFullYear()}`;
  },
  getDatetimeFormatEn(date) {
    const { day, month } = MyUtil.getMonthDay(date);
    const { hour, minute } = MyUtil.getHourMinute(date);
    return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}`;
  },
  getDateByDateFormat(dateStr) {
    const dateString = dateStr.toString();
    const hour = dateString.substr(0, 2);
    const minute = dateString.substr(3, 2);
    const day = dateString.substr(6, 2);
    const month = dateString.substr(9, 2);
    const year = dateString.substr(12, 4);
    const date = new Date(year, month - 1, day, hour, minute);
    return date;
  },
  getReturnDateByRentalDate(date) {
    const returnDate = new Date(date);
    returnDate.setDate(returnDate.getDate() + 1);
    returnDate.setHours(19, 0, 0);
    return returnDate;
  },
  getDateRangeFormat(start, end) {
    const startDate = MyUtil.getDatetimeFormat(new Date(start));
    const endDate = MyUtil.getDatetimeFormat(new Date(end));
    return `${startDate} - ${endDate}`;
  },
  getMinDateByDate(date) {
    const minDate = new Date(date);
    if (minDate.getHours() > 16) {
      minDate.setDate(minDate.getDate() + 1);
      minDate.setHours(6, 0, 0);
    } else minDate.setHours(minDate.getHours() + 6);
    return minDate;
  },
  formatVehicleName: (name) => {
    let i = 0;
    const strLength = name.length;
    for (i; i < strLength; i += 1) {
      name = name.replace(' ', '-');
    }
    return name;
  },
  getVehicleName: (name) => {
    let i = 0;
    const strLength = name.length;
    for (i; i < strLength; i += 1) {
      name = name.replace('-', ' ');
    }
    return name;
  },
  rangePrice: (priceFrom, priceTo) =>
    `${MyUtil.currencyFormat(priceFrom)} VNĐ - ${MyUtil.currencyFormat(
      priceTo
    )} VNĐ`,
  checkDate: () => {
    const start = reactLocalStorage.get('booking.rental_date');
    const end = reactLocalStorage.get('booking.return_date');
    const startDate = new Date(start).getTime();
    const endDate = new Date(end).getTime();
    const now = new Date().getTime();
    if (startDate < now || endDate < now || startDate > endDate) {
      reactLocalStorage.set('booking.rental_date', '');
      reactLocalStorage.set('booking.return_date', '');
    }
  },

  getMonthDay(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;
    return { day, month };
  },
  getHourMinute(date) {
    let hour = date.getHours();
    let minute = date.getMinutes();
    if (hour < 10) hour = `0${hour}`;
    if (minute < 10) minute = `0${minute}`;
    return { hour, minute };
  },
  getEncodePhone(phone) {
    return `${phone.substr(0, 3)}xxx${phone.substr(6, phone.length - 6)}`;
  },
  formatListVehicle(list, type) {
    const arr = [];
    if (list && list.length > 0) {
      list.map((item, index) => {
        let vehicle = item;
        vehicle = Object.assign(vehicle, item.vhc);
        vehicle = Object.assign(vehicle, item.part);
        delete vehicle.vhc;
        delete vehicle.part;
        if (type === 1) vehicle.vhc_seat_num += ' chỗ';
        vehicle.vhc_part_defa_prie = this.currencyFormat(
          vehicle.vhc_part_defa_prie
        );
        vehicle.index = index + 1;
        arr.push(vehicle);
      });
    }
    return arr;
  },

  clean: (obj) => {
    const propNames = Object.getOwnPropertyNames(obj);

    for (let i = 0; i < propNames.length; i += 1) {
      const propName = propNames[i];
      if (obj[propName] === undefined || obj[propName] === '') {
        // eslint-disable-next-line no-param-reassign
        delete obj[propName];
      }
    }
    return obj;
  },

  convertVehicle(item) {
    let vehicle = item;
    vehicle = Object.assign(vehicle, item.vhc);
    vehicle = Object.assign(vehicle, item.part);
    delete vehicle.vhc;
    delete vehicle.part;
    if (item.vhc_type_id === 1) vehicle.vhc_seat_num += ' chỗ';
    return vehicle;
  },
  convertMoney(stringValue) {
    if (stringValue && stringValue !== '') {
      const value = `${stringValue}`;
      const str = value.replace(/\./g, '');
      return parseInt(str, 10) ? parseInt(str, 10) : str;
    }
    return '';
  },
  convertManyOption(value) {
    if (value) {
      let procs = {};
      const arr = value.split(',');
      arr.forEach((item) => {
        const element = item.split(':');
        procs = Object.assign(procs, { [element[0]]: element[1] });
      });

      return procs;
    }
    return value;
  },
  isLastDay: (dt) => {
    const date = new Date(dt.getTime());
    const month = date.getMonth();

    date.setDate(date.getDate() + 1);
    return date.getMonth() !== month;
  },
  isStartDay: (dt) => {
    const date = new Date(dt.getTime());
    const month = date.getMonth();

    date.setDate(date.getDate() - 1);
    return date.getMonth() !== month;
  },
  makeTitle: (slugedText) => {
    if (slugedText) {
      // eslint-disable-next-line func-names
      return slugedText.replace(/-/g, ' ').replace(/\b[a-z]/g, function () {
        // eslint-disable-next-line prefer-rest-params
        return arguments[0].toUpperCase();
      });
    }
    return '';
  },
  hasPermission: (routePath, permissionCheck) => {
    const userInfo = reactLocalStorage.getObject('user.info');
    const userGroupPermission = get(userInfo, 'permission', []);
    const routePathPermission =
      find(userGroupPermission, { route_path: routePath }) || [];

    const permission = get(routePathPermission, 'permission', []);
    return permission.indexOf(permissionCheck) !== -1;
  },
  getQueryParam: () => {
    const params = new URLSearchParams(window.location.search);
    let paramObj = {};

    for (const key of params.keys()) {
      paramObj[key] = params.get(key);
    }

    return paramObj;
  },
  isJsonString: (jsonString) => {
    try {
      const json = JSON.parse(jsonString);
      return typeof json === 'object';
    } catch (e) {
      return false;
    }
  },
};

export default MyUtil;
